import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { v3_fat_projects } from '../../actions/v3/fat';
import Layout from '../../components/common/pageLayout'
import constant from '../../constant';
import './fat.css'
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Filter from '../../components/FAT/List/filter';
import List from '../../components/FAT/List/index'
import { replacePageState } from '../../utils';

const Index = (props) => {

    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState(null)
    const [currentPage, setCurrentPage] = useState(page ? page : 1)
    const [limit, setLimit] = useState(10)
    const [keyword, setKeyword] = useState('');
    const [groupBy, setGroupBy] = useState('none');
    useEffect(() => {
        v3_fat_projects(currentPage, limit, keyword, groupBy).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.fatIndex.url, {
                    page: currentPage
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }, [currentPage, limit])

    useEffect(() => {
        setCurrentPage(1)
        v3_fat_projects(1, limit, keyword, groupBy).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.fatIndex.url, {
                    page: currentPage
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }, [keyword, groupBy])

    return (
        <Layout title='FAT'>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12 ">
                                    <div className="appraisal-report-table-responsive">
                                        <Filter
                                            keyword={keyword}
                                            setKeyword={setKeyword}
                                            groupBy={groupBy}
                                            setGroupBy={setGroupBy}

                                        />

                                        {data && <List
                                            data={data}
                                            limit={limit}
                                            handlePageChange={(newPage) => setCurrentPage(newPage)}
                                        />}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Index